import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { TelXLAvatarComponent } from '@dxp/elements';
import { IContact } from '@dxp/core/models';

@Component({
    selector: 'contact-directories-details-initials',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TelXLAvatarComponent],
    templateUrl: './contact-details-initials.component.html',
    styleUrl: './contact-details-initials.component.scss',
})
export class ContactDirectoriesDetailsInitialsComponent {
    contact = input.required<IContact>();

    name = computed<string>(() => {
        const name = this.contact().fullName;
        return name && name.length > 0 ? name : 'Unknown Contact';
    });
}
